import {graphql} from '../../../__generated__';

export const QUERY_SELECT_CLIENTS = graphql(`
    query selectClients (
        $filters: ClientFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []
    ) {
        clients(filters: $filters, pagination: $pagination, sort: $sort) {
            documentId
            firstName
            lastName
            middleName
        }
    }
`);

export const QUERY_CLIENTS = graphql(`
    query clients (
        $filters: ClientFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []
    ) {
        clients(filters: $filters, pagination: $pagination, sort: $sort) {
            documentId
            firstName
            lastName
            middleName
            phone
            enabled
            birthday
            iikoBalance
            iikoBalanceAt
            group {
                documentId
                name
            }
            parents {
                documentId
                firstName
                lastName
            }
        }
    }
`);

export const QUERY_CLIENT = graphql(`
    query client ($documentId: ID!,) {
        client(documentId: $documentId) {
            documentId
            firstName
            lastName
            middleName
            phone
            enabled
            birthday
            group {
                documentId
                name
            }
            parents {
                documentId
                firstName
                lastName
            }
        }
    }
`);

export const UPDATE_CLIENT = graphql(`
    mutation updateClient ($id: ID!, $data: ClientInput!) {
        updateClient(documentId: $id, data: $data) {
            documentId
        }
    }
`);

export const CREATE_CLIENT = graphql(`
    mutation createClient ($data: ClientInput!) {
        createClient(data: $data) {
            documentId
        }
    }
`);
